import React from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import VatRateHistoryForm from '../../../components/forms/VatRateHistoryForm';
import { useCreateVatRateHistory } from '../../../hooks/useVatRateHistoryApi';
import { useNavigate } from 'react-router-dom';
import { VatRateHistoryDTO } from '../../../services/apiClient';

const VatRateHistoryCreate: React.FC = () => {
  const createMutation = useCreateVatRateHistory();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'VAT Rates', href: '/admin/vatratehistories' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: VatRateHistoryDTO) => {
    try {
      await createMutation.mutateAsync(data);
      navigate('/admin/vatratehistories');
    } catch (error) {
      console.error('Error creating VatRateHistory:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/vatratehistories"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.VatRateHistory.Edit"
    >
      <VatRateHistoryForm
        initialValues={{} as VatRateHistoryDTO}
        onSubmit={handleSubmit}
        onCancel={() => navigate('/admin/vatratehistories')}
      />
    </AdminLayout>
  );
};

export default VatRateHistoryCreate;
